import {
  API_CALL,
  UPDATE_PACKAGE,
  PACKAGE_FAILED,
  ADD_OR_UPDATE_PACKAGES_IN_ORDER,
  RECEIVE_PACKAGE,
  REQUEST_CLONE_PACKAGE,
  ADD_PACKAGES_TO_ORDER,
  CLONE_PACKAGE_FAILED,
  DELETE_PACKAGE,
  RECEIVE_DELETED_PACKAGE,
  REQUEST_PUSH_PACKAGES,
  RECEIVE_PUSH_PACKAGES,
  PUSH_FAILED
} from './types';

import { hasError } from './actionHelpers';
import {toast} from "react-toastify";

export const savePackage = pack => ({
  type: API_CALL,
  onRequest: UPDATE_PACKAGE,
  onResponse: ADD_OR_UPDATE_PACKAGES_IN_ORDER,
  onError: PACKAGE_FAILED,
  responseKey: 'packages',
  payload: {
    method: 'POST',
    url: pack.id ? `/packages/${pack.id}` : '/packages/',
    data: pack
  },
  packageId: pack.id || 0
});

export const saveAndNotify = pack => (dispatch, getState) => {
  let message = `Saving package ${pack.id || ''}`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(savePackage(pack)).then(() => {
    const err = hasError(getState(), 'orderRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err});
    } else {
      message = `Saved package ${pack.id || ''}`;
      toast.success(message, { theme: 'colored', toastId: message });
    }
  });
};

export const saveMultiplePackages = (imports) => ({
  type: API_CALL,
  onRequest: UPDATE_PACKAGE,
  onResponse: ADD_OR_UPDATE_PACKAGES_IN_ORDER,
  onError: PACKAGE_FAILED,
  responseKey: 'packages',
  payload: {
    method: 'POST',
    url: `/packages`,
    data: imports
  }
});

export const saveMultiplePackagesAndNotify = (imports) => (dispatch, getState) => {
  let message = `Saving multiple packages`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(saveMultiplePackages(imports)).then(() => {
    const err = hasError(getState(), 'packageRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
    } else {
      message = `Saved ${imports.packages.length} packages`;
      toast.success(message, { theme: 'colored', toastId: message });
    }
  })
};

export const clonePackage = (id) => {
  return {
    type: API_CALL,
    onRequest: REQUEST_CLONE_PACKAGE,
    onResponse: ADD_PACKAGES_TO_ORDER,
    onError: CLONE_PACKAGE_FAILED,
    responseKey: 'packages',
    payload: {
      method: 'POST',
      url: `/packages/${id}/clone`,
      data: { id }
    }
  };
};

export const clonePackages = (orderId, ids, numCopies) => {
  return {
    type: API_CALL,
    onRequest: REQUEST_CLONE_PACKAGE,
    onResponse: ADD_PACKAGES_TO_ORDER,
    onError: CLONE_PACKAGE_FAILED,
    responseKey: 'packages',
    payload: {
      method: 'POST',
      url: `/packages/cloneMultiple`,
      data: { orderId: orderId, packageIds: ids.join(), numCopies: numCopies }
    }
  };
};

export const deletePackage = (id) => ({
  type: API_CALL,
  onRequest: DELETE_PACKAGE,
  onResponse: RECEIVE_DELETED_PACKAGE,
  onError: PACKAGE_FAILED,
  payload: {
    method: 'DELETE',
    url: `/packages/${id}`
  }
});

export const deletePackages = (ids) => ({
  type: API_CALL,
  onRequest: DELETE_PACKAGE,
  onResponse: RECEIVE_DELETED_PACKAGE,
  onError: PACKAGE_FAILED,
  payload: {
    method: 'DELETE',
    url: `/packages`,
    data: { packageIds: ids.join() }
  }
});

export const pushPackages = (ioId, packageIds, pushRules) => ({
  type: API_CALL,
  onRequest: REQUEST_PUSH_PACKAGES,
  onResponse: RECEIVE_PUSH_PACKAGES,
  onError: PUSH_FAILED,
  payload: {
    method: 'PUT',
    url: '/packages',
    data: { ioId: ioId, packageIds: packageIds.join(), pushRules: pushRules }
  }
});

export const pushPackagesAndNotify = (ioId, packageIds, pushRules) => (dispatch, getState) => {
  let message = `Pushing multiple packages ${ioId}`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(pushPackages(ioId, packageIds, pushRules)).then(() => {
    const err = hasError(getState(), 'packageRequest', dispatch);
    const { pushResult } = getState().packageRequest;
    if (err) {
      message = 'No packages to push';
      toast.error(err, {theme: 'colored', toastId: err});
    } else if (!pushResult || !pushResult.direct) {
      toast.error(err, {theme: 'colored', toastId: err});
    } else if (pushResult['direct']) {
      message = `Placements pushed to GAM: ${pushResult.placements.length || 1}`;
      toast.success(message, { theme: 'colored', toastId: message });
    } else {
      message = `Placements being pushed to GAM: ${pushResult.placements.length || 1}`;
      toast.info(message, { theme: 'colored', toastId: message });
    }
  })
};

export const setPackage = pack => ({
  type: RECEIVE_PACKAGE,
  pack
});

export const setError = error => ({
  type: PACKAGE_FAILED,
  error
});
